import { useCartContext } from "../../customHooks/useCart";
import { getPrice } from "../../utils/translator";
import { freePrice } from "./pricing";

/**
 * Prices on the Care+ V3 treatment + plan pages, in the cart's currency (set by
 * ChooseTreatmentRouter from the country), with the same locale and rate the checkout pages
 * pass to getPrice — so £ in the UK and the plan page never shows a different total than checkout.
 */
export const useCarePlusPrice = () => {
  const { cartCurrency } = useCartContext();
  const locale = cartCurrency?.locale || "de-DE";
  const rate = cartCurrency?.rate ?? 1;
  return {
    formatPrice: (value: number) => getPrice(value, locale, rate),
    formatFreePrice: () => freePrice(locale),
  };
};
